/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class MPIApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `MPIModule.forRoot()`
 */
export interface MPIApiConfigurationParams {
  rootUrl?: string;
}
